import { render } from "./InertiaButtonLogin.vue?vue&type=template&id=34c78540"
import script from "./InertiaButtonLogin.vue?vue&type=script&lang=js"
export * from "./InertiaButtonLogin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__